import React, { useState } from 'react';
import ExpandMoreOutlined from '@mui/icons-material/ExpandMoreOutlined';
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';

const ENUM_CATEGORIES = [
  {
    key: 'departments',
    label: 'Departments',
    description: 'Team departments for personnel profiles',
    defaults: ['Audio', 'Lighting', 'Video', 'Staging', 'Rigging', 'Production', 'Logistics', 'Creative', 'Marketing', 'Finance'],
  },
  {
    key: 'titles',
    label: 'Positions & Titles',
    description: 'Job titles used across personnel profiles',
    defaults: ['Tour Manager', 'Production Manager', 'Stage Manager', 'FOH Engineer', 'Monitor Engineer', 'LD', 'Video Director', 'Carpenter', 'Wardrobe', 'Bus Driver'],
  },
  {
    key: 'event_types',
    label: 'Event Types',
    description: 'Classification labels for events within projects',
    defaults: ['Show', 'Rehearsal', 'Load In', 'Load Out', 'Travel Day', 'Day Off', 'Press', 'Meeting'],
  },
  {
    key: 'vendor_types',
    label: 'Vendor Service Types',
    description: 'Service categories for vendor companies',
    defaults: ['Audio', 'Lighting', 'Video', 'Backline', 'Trucking', 'Bussing', 'Catering', 'Security', 'Local Crew', 'Production'],
  },
  {
    key: 'project_status',
    label: 'Project Status',
    description: 'Status labels for projects',
    defaults: ['Active', 'Upcoming', 'On Hold', 'Completed', 'Cancelled'],
  },
  {
    key: 'show_positions',
    label: 'Show Positions',
    description: 'Roles assignable to personnel for specific shows',
    defaults: ['FOH', 'Monitors', 'LD', 'Spots', 'Video', 'Backline', 'Stage Manager', 'Tour Manager'],
  },
];

export default function EnumSettings() {
  const [expanded, setExpanded] = useState(null);

  return (
    <div style={{ maxWidth: '640px', display: 'flex', flexDirection: 'column', gap: '12px' }}>

      {/* Coming soon banner */}
      <div style={{
        backgroundColor: 'rgba(229,192,75,0.07)',
        border: '1px solid rgba(229,192,75,0.25)',
        borderRadius: '8px',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '4px',
      }}>
        <span style={{ fontSize: '14px', color: '#E5C04B', flexShrink: 0 }}>✦</span>
        <span style={{
          fontFamily: "'Roboto', sans-serif",
          fontSize: '13px',
          color: '#E5C04B',
          fontWeight: 500,
        }}>
          List customization is coming soon. Below are the default values currently active.
        </span>
      </div>

      {/* Accordion items */}
      {ENUM_CATEGORIES.map((cat) => {
        const isOpen = expanded === cat.key;
        return (
          <div
            key={cat.key}
            style={{
              backgroundColor: '#2a2a2a',
              border: '1px solid #3a3a3a',
              borderRadius: '8px',
              overflow: 'hidden',
            }}
          >
            <div
              onClick={() => setExpanded(isOpen ? null : cat.key)}
              style={{
                padding: '14px 18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              <div>
                <div style={{
                  fontFamily: "'Roboto', sans-serif",
                  fontWeight: 600,
                  fontSize: '14px',
                  color: '#F5F5F5',
                }}>
                  {cat.label}
                </div>
                <div style={{
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: '12px',
                  color: '#565656',
                  marginTop: '2px',
                }}>
                  {cat.description}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                <span style={{
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: '12px',
                  color: '#565656',
                }}>
                  {cat.defaults.length} items
                </span>
                {isOpen
                  ? <ExpandMoreOutlined style={{ fontSize: 18, color: '#888888' }} />
                  : <ChevronRightOutlined style={{ fontSize: 18, color: '#888888' }} />
                }
              </div>
            </div>

            {isOpen && (
              <div style={{
                borderTop: '1px solid #3a3a3a',
                padding: '16px 18px',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
              }}>
                {cat.defaults.map((item) => (
                  <div
                    key={item}
                    style={{
                      backgroundColor: '#1a1a1a',
                      border: '1px solid #3a3a3a',
                      borderRadius: '4px',
                      padding: '4px 12px',
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: '13px',
                      color: '#888888',
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
